import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import store from '../store';
import http from './utils/http';
import utils from './utils/utils';
import config from './utils/config';
import commonHeader from './components/header/index'
import personal from './components/personal/personal-left'
import i18n from './lang'
Vue.component('personal-left', personal)
Vue.component('commonHeader', commonHeader)

import {
  Notification,
} from 'element-ui'

Vue.prototype.$notify = Notification

// router.beforeEach((to, from, next) => {
//   // chrome
//   document.body.scrollTop = 0
//   // firefox
//   document.documentElement.scrollTop = 0
//   // safari
//   window.pageYOffset = 0
//   next()
// })

Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.prototype.$config = config;
Vue.prototype.$store = store; //挂载在 Vue 实例上
/* eslint-disable no-new */

Vue.use(ElementUI,{
  i18n:(key,value)=>i18n.t(key,value)
});


Vue.prototype.$jx = utils



new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    store, 
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js